const validPathRegex = /^\/([a-zA-Z0-9\-_#?%&=\.]+[\/]?)*$/;

export const isValidPath = (path: string) => validPathRegex.test(path);
